// Typographic S | M logo rendered in white on the site background.
// Scales entirely from the parent font-size (use text-[..px] utilities).
export default function Logo({ className = "", wordmark = true, ...props }) {
  return (
    <span
      className={`inline-flex flex-col items-center leading-none select-none text-current ${className}`}
      style={{ fontFamily: '"Playfair Display", Georgia, serif' }}
      {...props}
    >
      <span className="flex items-center font-bold" style={{ letterSpacing: "0.04em" }}>
        <span>S</span>
        <span
          className="font-light"
          style={{ margin: "0 0.26em", transform: "scaleY(1.0)", opacity: 0.85 }}
        >
          |
        </span>
        <span>M</span>
      </span>
      {wordmark && (
        <span
          className="font-semibold uppercase"
          style={{
            fontSize: "0.15em",
            letterSpacing: "0.4em",
            marginTop: "1.5em",
            paddingLeft: "0.4em",
          }}
        >
          Sabala Management LLC
        </span>
      )}
    </span>
  );
}
